// Surveyor links (Ben 27 Oct: links on record; 7 days to 1 year; cancel one at a time). The building
// card gives, lists and cancels them through EVSiQ's public-links function, which checks the caller
// with the TCS database itself (their own sign-in) — so this sends only the TCS token.
import { getSupabaseToken } from '../../../shared/supabase';

/** Repeated in scripts/lib/evsiq.mjs; evsiq-public-links.test.ts keeps the two equal. */
export const EVSIQ_PUBLIC_LINKS_URL = 'https://idkyvmfaqfrmkprykonq.supabase.co/functions/v1/public-links';

/** The lengths a link may last, in days (the function refuses any other). */
export const LINK_LENGTHS = [
  { days: 7, label: '7 days' },
  { days: 30, label: '30 days' },
  { days: 90, label: '90 days' },
  { days: 365, label: '1 year' },
] as const;

export interface SurveyorLink {
  id: string;
  kind: 'kiosk' | 'administrator';
  issued_to: string | null;
  issued_by_name: string | null;
  created_at: string;
  expires_at: string;
}
export interface SurveyorLinks { on_evsiq: boolean; facility?: { name: string }; links?: SurveyorLink[] }

/** A refusal the box hides on (not this person's building), kept apart from a real failure. */
export class NotYoursError extends Error {}

async function call<T>(body: Record<string, unknown>): Promise<T> {
  const jwt = getSupabaseToken();
  if (!jwt) throw new Error('You need to be signed in to the TCS app.');
  const res = await fetch(EVSIQ_PUBLIC_LINKS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${jwt}` },
    body: JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (res.status === 403) throw new NotYoursError(data.error ?? 'Not your building.');
  if (!res.ok) throw new Error(data.error ?? `EVSiQ answered ${res.status}`);
  return data;
}

export const listSurveyorLinks = (facilityId: string) =>
  call<SurveyorLinks>({ action: 'list', facility_id: facilityId });

export const issueSurveyorLink = (facilityId: string, issuedTo: string, days: number) =>
  call<{ url: string; link: { id: string; issued_to: string; expires_at: string } }>(
    { action: 'issue', facility_id: facilityId, issued_to: issuedTo, days });

export const cancelSurveyorLink = (facilityId: string, linkId: string) =>
  call<{ cancelled: true }>({ action: 'cancel', facility_id: facilityId, link_id: linkId });

/** "Oct 27, 2027" — a link's expiry date as the box shows it. */
export function fmtExpiry(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
